import { NoParamEndpointConstructor, SingleParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/rtm-groups'

interface Endpoints {
  getAll: NoParamEndpointConstructor
  create: NoParamEndpointConstructor
  remove: SingleParamEndpointConstructor
  update: SingleParamEndpointConstructor
}

export const rtmGroupsEndpoints: Endpoints = {
  getAll: () => baseUrl,
  create: () => baseUrl,
  remove: (id) => `${baseUrl}/${id}`,
  update: (id) => `${baseUrl}/${id}`,
}
